import { useEffect } from 'react';

export default function useMetaTags({ 
    description, 
    title,
    image = 'https://celeritas.live/og-image.png',
    url 
}) {
    useEffect(() => {
        // Atualizar meta description
        if (description) {
            let metaDescription = document.querySelector("meta[name='description']");
            if (!metaDescription) {
                metaDescription = document.createElement('meta');
                metaDescription.name = 'description';
                document.head.appendChild(metaDescription);
            }
            metaDescription.content = description;
        }

        // Atualizar OpenGraph tags
        if (title) {
            let ogTitle = document.querySelector("meta[property='og:title']");
            if (!ogTitle) {
                ogTitle = document.createElement('meta');
                ogTitle.setAttribute('property', 'og:title');
                document.head.appendChild(ogTitle);
            }
            ogTitle.content = title;
        }

        if (description) {
            let ogDescription = document.querySelector("meta[property='og:description']");
            if (!ogDescription) {
                ogDescription = document.createElement('meta');
                ogDescription.setAttribute('property', 'og:description');
                document.head.appendChild(ogDescription);
            }
            ogDescription.content = description;
        }

        if (image) {
            let ogImage = document.querySelector("meta[property='og:image']");
            if (!ogImage) {
                ogImage = document.createElement('meta');
                ogImage.setAttribute('property', 'og:image');
                document.head.appendChild(ogImage);
            }
            ogImage.content = image;
        }

        if (url) {
            let ogUrl = document.querySelector("meta[property='og:url']");
            if (!ogUrl) {
                ogUrl = document.createElement('meta');
                ogUrl.setAttribute('property', 'og:url');
                document.head.appendChild(ogUrl);
            }
            ogUrl.content = url;
        }

        // Atualizar Twitter Card tags
        if (title) {
            let twitterTitle = document.querySelector("meta[name='twitter:title']");
            if (!twitterTitle) {
                twitterTitle = document.createElement('meta');
                twitterTitle.name = 'twitter:title';
                document.head.appendChild(twitterTitle);
            }
            twitterTitle.content = title;
        }

        if (description) {
            let twitterDescription = document.querySelector("meta[name='twitter:description']");
            if (!twitterDescription) {
                twitterDescription = document.createElement('meta');
                twitterDescription.name = 'twitter:description';
                document.head.appendChild(twitterDescription);
            }
            twitterDescription.content = description;
        }

        if (image) {
            let twitterImage = document.querySelector("meta[name='twitter:image']");
            if (!twitterImage) {
                twitterImage = document.createElement('meta');
                twitterImage.name = 'twitter:image';
                document.head.appendChild(twitterImage);
            }
            twitterImage.content = image;
        }
    }, [description, title, image, url]);
}
